import React, { useState, useEffect } from "react";
import axios from "../../../../services/auth/jwt/config";
import { Box, FormControlLabel, Radio, Typography } from "@material-ui/core";

const RadioItem = ({ item, formId, fieldId }) => {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (formId) {
      getRemainingCount();
    }
  }, []);

  const getRemainingCount = () => {
    try {
      axios
        .post(`/formfilled/count/selection`, {
          form: formId,
          selectionId: item._id,
          userInput: item.title,
          formField: fieldId,
        })
        .then(({ data }) => {
          setCount(data.entries);
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data.msgFa);
          } else {
            console.log(error.message);
          }
        });
    } catch (error) {
      console.log(error.message);
    }
  };

  return (
    <Box display={"flex"} alignItems={"center"}>
      <FormControlLabel
        value={item.title}
        control={<Radio />}
        label={item.title}
        disabled
      />
      {item.limits?.count && formId && (
        <Typography color="textSecondary">
          (ظرفیت باقی مانده: {count})
        </Typography>
      )}
    </Box>
  );
};

export default RadioItem;
